import type { AuthProvider } from '@famecreator/websocket/core';

import { supabaseAuthService } from '../services/supabase-auth-service';

/**
 * Adapter to connect Supabase auth service with the websocket package
 */
export const websocketAuthAdapter: AuthProvider = {
  async getAccessToken(): Promise<string | null> {
    return await supabaseAuthService.getAccessToken();
  },
};
